module.exports = __webpack_public_path__ + "img/logo_hec_digital_lab.7c8824fa.png";